// src/apis/uploadApi.js
import apiClient from './ApiInterceptor';

export const uploadImage = async (file, folder) => {
  const formData = new FormData();
  formData.append('file', file);
  if (folder) {
    formData.append('folder', folder);
  }

  // apiClient ya incluye la base URL; especificamos encabezado multipart
  const response = await apiClient.post('/upload/image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const fetchImages = async (folder) => {
  const url = folder ? `/upload/images?folder=${folder}` : '/upload/images';
  const response = await apiClient.get(url);
  return response.data;
};
